import { render, staticRenderFns } from "./SalesPerson.vue?vue&type=template&id=9ccc9c86&scoped=true&"
import script from "./SalesPerson.vue?vue&type=script&lang=js&"
export * from "./SalesPerson.vue?vue&type=script&lang=js&"
import style0 from "./SalesPerson.vue?vue&type=style&index=0&id=9ccc9c86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccc9c86",
  null
  
)

export default component.exports